import React, { useState, useEffect } from "react";
import axios from "axios";

const WeeklyLoanCustomers = () => {
  const [loanData, setLoanData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [nameFilter, setNameFilter] = useState("");
  const [daysFilter, setDaysFilter] = useState("");
  const baseURL = process.env.REACT_APP_BASE_URL;

  useEffect(() => {
    const accessToken = sessionStorage.getItem("access_token");
    axios
      .get(`${baseURL}/fetchLoanData`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((response) => {
        setLoanData(response.data);
        console.log(response.data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching loan data", error);
        setLoading(false);
      });
  }, []);

  const formatToDisplayDate = (date) => {
    const [year, month, day] = date.split("-");
    return `${day}-${month}-${year}`;
  };

  const filteredData = loanData.filter(
    (item) => item.scheme_name?.toLowerCase() === "weekly collection"
  );

  // Group data by loan_id
  const groupByLoanId = (data) => {
    const grouped = {};

    data.forEach((item) => {
      if (!grouped[item.loan_id]) {
        grouped[item.loan_id] = {
          ...item,
          total_emi_amount: 0,
        };
      }
      grouped[item.loan_id].total_emi_amount += Number(item.log_emi_amount);
    });

    return Object.values(grouped);
  };

  const groupedData = groupByLoanId(filteredData);

  const calculatePendingAmount = (
    loan_emi_amount,
    rem_amount,
    value,
    daysCount,
    initialProfit,
    amount
  ) => {
    const currentDuration = parseInt(daysCount / value);
    const currEmiAmount = currentDuration * loan_emi_amount;
    const remAmount = Number(amount) - Number(rem_amount);
    const pending_amount = currEmiAmount - remAmount;
    return pending_amount >= 0 ? parseFloat(pending_amount.toFixed(2)) : 0;
  };

  const calculateDaysFromEndDate = (endDate) => {
    const end = new Date(endDate);
    const currentDate = new Date();
    const differenceInMs = end - currentDate;
    const pendingDays = Math.ceil(differenceInMs / (1000 * 60 * 60 * 24));
    return pendingDays >= 0 ? pendingDays : 0;
  };

  const calculateDaysFromEmiDate = (emiDate) => {
    const emi = new Date(emiDate);
    const currentDate = new Date();
    emi.setHours(0, 0, 0, 0);
    currentDate.setHours(0, 0, 0, 0);
    const differenceInMs = currentDate - emi;
    return differenceInMs === 0
      ? 1
      : Math.max(Math.floor(differenceInMs / (1000 * 60 * 60 * 24)) + 1, 0);
  };
  let totalEMI = 0;
  let totalPending = 0;

  groupedData.forEach((item) => {
    const daysCount = calculateDaysFromEmiDate(item.emi_date);
    const pendingAmount = calculatePendingAmount(
      Number(item.loan_emi_amount),
      Number(item.rem_amount),
      parseInt(item.num),
      daysCount,
      Number(item.initial_profit),
      Number(item.amount)
    );
    totalPending += Number(item.rem_amount);
    totalEMI += Number(item.total_emi_amount);
  });

  const filteredGroupedData = groupedData.filter((item) => {
    const pendingDays = calculateDaysFromEndDate(item.end_date);
    const nameMatches = item.tamilname
      .toLowerCase()
      .includes(nameFilter.toLowerCase());
    const daysMatches =
      daysFilter === "" || pendingDays === parseInt(daysFilter);
    return nameMatches && daysMatches;
  });

  const getDayOfWeek = (dateString) => {
    const date = new Date(dateString);
    const options = { weekday: "long" };
    return date.toLocaleDateString("en-US", options); // This will return the day of the week, like "Monday"
  };

  const renderTable = () => (
    <div id="printable-weeklyloancustomers-content">
      <h2 className="font-bold text-lg mb-4 text-center">
        Weekly Loan Collection
      </h2>

      <div className="flex justify-center gap-8 mb-4">
        <p className="font-semibold text-gray-700">
          Total EMI: ₹{totalEMI.toFixed(2)}
        </p>
        <p className="font-semibold text-gray-700">
          Total Pending: ₹{totalPending.toFixed(2)}
        </p>
      </div>
      <div className="flex justify-center gap-4 mb-6">
        <input
          type="text"
          placeholder="Filter by Customer Name"
          className="border p-2 rounded w-1/4 filter-input"
          value={nameFilter}
          onChange={(e) => setNameFilter(e.target.value)}
        />
        <input
          type="number"
          placeholder="Filter by Pending Days"
          className="border p-2 rounded w-1/4 filter-input"
          value={daysFilter}
          onChange={(e) => setDaysFilter(e.target.value)}
        />
      </div>
      <table className="table-auto w-full border-collapse border border-gray-300">
        <thead>
          <tr>
            <th
              className={
                "px-2 py-1 text-sm border border-gray-500 w-4 text-left"
              }
              style={{ paddingTop: "4px", paddingBottom: "8px" }}
            >
              S.No
            </th>
            <th
              className={
                "px-2 py-1 text-sm border border-gray-500 w-4 text-left"
              }
              style={{ paddingTop: "4px", paddingBottom: "8px" }}
            >
              Total EMI
            </th>
            <th
              className={
                "px-2 py-1 text-sm border border-gray-500 w-20 text-left"
              }
              style={{ paddingTop: "4px", paddingBottom: "8px" }}
            >
              Date
            </th>
            <th
              className={
                "px-2 py-1 text-sm border border-gray-500 w-4 text-left"
              }
              style={{ paddingTop: "4px", paddingBottom: "8px" }}
            >
              Day
            </th>
            <th
              className={
                "px-2 py-1 text-sm border border-gray-500 w-4  text-left"
              }
              style={{ paddingTop: "4px", paddingBottom: "8px" }}
            >
              Customer Name
            </th>
            <th
              className={
                "px-2 py-1 text-sm border border-gray-500 w-4 text-left"
              }
              style={{ paddingTop: "4px", paddingBottom: "8px" }}
            >
              weeks
            </th>
            <th
              className={
                "px-2 py-1 text-sm border border-gray-500 w-4 text-left"
              }
              style={{ paddingTop: "4px", paddingBottom: "8px" }}
            >
              Total Pending
            </th>
            <th
              className={
                "px-2 py-1 text-sm border border-gray-500 w-4 text-left"
              }
              style={{ paddingTop: "4px", paddingBottom: "8px" }}
            >
              Pending
            </th>
            {[...Array(6)].map((_, i) => (
              <th
                key={i}
                className={"px-2 py-1 border border-gray-500 text-sm w-6 "}
                style={{ paddingTop: "4px", paddingBottom: "8px" }}
              ></th>
            ))}
          </tr>
        </thead>
        <tbody>
          {filteredGroupedData.map((item, index) => {
            const totalEMI = item.total_emi_amount.toFixed(2);
            const daysCount = calculateDaysFromEmiDate(item.emi_date);
            const pendingAmount = calculatePendingAmount(
              Number(item.loan_emi_amount),
              Number(item.rem_amount),
              parseInt(item.num),
              daysCount,
              Number(item.initial_profit),
              Number(item.amount)
            );
            const pendingDays = calculateDaysFromEndDate(item.end_date);
            const textColor =
              pendingAmount === 0
                ? "text-red-600 font-semibold"
                : "text-black-900 font-semibold";

            // Alternate row background color
            const rowColor = index % 2 === 0 ? "bg-gray-100" : "bg-white";

            return (
              <tr key={item.loan_id} className={rowColor}>
                <td
                  className={`px-2 py-1 border border-gray-500 w-4 ${textColor}`}
                  style={{ paddingTop: "4px", paddingBottom: "8px" }}
                >
                  {index + 1}
                </td>
                <td
                  className={`px-2 py-1 border border-gray-500 w-4 ${textColor}`}
                  style={{ paddingTop: "4px", paddingBottom: "8px" }}
                >
                  {totalEMI}
                </td>
                <td
                  className={`px-2 py-1 border border-gray-500 w-20 ${textColor}`}
                  style={{ paddingTop: "4px", paddingBottom: "8px" }}
                >
                  {formatToDisplayDate(item.date)}
                </td>
                <td
                  className={`px-2 py-1 border border-gray-500 w-4 ${textColor}`}
                  style={{ paddingTop: "4px", paddingBottom: "8px" }}
                >
                  {getDayOfWeek(item.date)}
                </td>

                <td
                  className={`px-2 py-1 border border-gray-500 w-4 ${textColor}`}
                  style={{ paddingTop: "4px", paddingBottom: "8px" }}
                >
                  {item.tamilname}
                </td>
                <td
                  className={`px-2 py-1 border border-gray-500 w-4 ${textColor}`}
                  style={{ paddingTop: "4px", paddingBottom: "8px" }}
                >
                  {pendingDays}
                </td>
                <td
                  className={`px-2 py-1 border border-gray-500 w-4 ${textColor}`}
                  style={{ paddingTop: "4px", paddingBottom: "8px" }}
                >
                  {item.rem_amount}
                </td>
                <td
                  className={`px-2 py-1 border border-gray-500 w-4 ${textColor}`}
                  style={{ paddingTop: "4px", paddingBottom: "8px" }}
                >
                  {pendingAmount}
                </td>

                {[...Array(6)].map((_, i) => (
                  <td
                    key={i}
                    className="px-2 py-1 border border-gray-500 text-left w-6"
                    style={{ paddingTop: "4px", paddingBottom: "8px" }}
                  ></td>
                ))}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <p className="text-lg font-semibold text-gray-600">Loading…</p>
      </div>
    );
  }
  return <div>{renderTable()}</div>;
};

export default WeeklyLoanCustomers;
